import { Link } from "react-router-dom";
import { PermissionType, User } from "../../../../../types/user.types";
import { GENDERS, ROLES } from "../../../../../constants/userConstants";
import { getFileUrl } from "../../../../../utils/file.utils";
import { Avatar, Popconfirm, Modal, Form, Input, Button, Tooltip, Progress, message } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
interface ProfileCardProps {
    userData: User;
    formatDate: (date: string | Date | undefined) => string;
    onEdit: (user: User) => void;
    onDeviceReset: (id: number) => void;
    onChangePassword: (id: number, newPassword: string) => void;
    onLeaveLimits?: (user: User) => void;
    currentUser: User;
}

export const ProfileCard: React.FC<ProfileCardProps> = ({ userData, formatDate, onEdit, onDeviceReset, onChangePassword, onLeaveLimits, currentUser }) => {
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState('');
    const [pwdModalOpen, setPwdModalOpen] = useState(false);
    const [pwdLoading, setPwdLoading] = useState(false);
    const [pwdForm] = Form.useForm();

    const generateStrongPassword = (len = 12) => {
        const lowers = "abcdefghijklmnopqrstuvwxyz";
        const uppers = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const nums   = "0123456789";
        const syms   = "!@#$%^&*()-_=+[]{};:,.?/";
        const all    = lowers + uppers + nums + syms;
      
        let pass = "";
        pass += lowers[Math.floor(Math.random() * lowers.length)];
        pass += uppers[Math.floor(Math.random() * uppers.length)];
        pass += nums[Math.floor(Math.random() * nums.length)];
        pass += syms[Math.floor(Math.random() * syms.length)];
        for (let i = 4; i < len; i++) pass += all[Math.floor(Math.random() * all.length)];
        // Shuffle
        return pass.split("").sort(() => Math.random() - 0.5).join("");
      };

      const handleGenerate = () => {
        const p = generateStrongPassword();
        pwdForm.setFieldsValue({ newPassword: p, confirm: p });
      };
      const handleCopy = async () => {
        const p = pwdForm.getFieldValue("newPassword");
        if (!p) return;
        try {
          await navigator.clipboard.writeText(p);
          message.success("Kopyalandı");
        } catch {
          message.warning("Kopyalama başarısız");
        }
      };
      
      const handlePwdSubmit = async (values: { newPassword: string; confirm: string }) => {
        try {
          setPwdLoading(true);
          await onChangePassword(userData?.id, values.newPassword);
          setPwdModalOpen(false);
          pwdForm.resetFields();
        } finally {
          setPwdLoading(false);
        }
      };
    return (
        <div className="card card-bg-1">
        <div className="card-body p-0">
            <span className="avatar avatar-xl avatar-rounded  m-auto d-flex mb-2">
                <Avatar
                    size={65}
                    src={userData?.profilePicture ? getFileUrl(userData?.profilePicture) : userData?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'}
                    className="rounded-circle"
                    alt="Img"
                />
            </span>
            <div className="text-center px-3 pb-3 border-bottom">
                <div className="mb-3">
                    <h5 className="d-flex align-items-center justify-content-center mb-1">
                        {userData?.firstName} {userData?.lastName}
                        {/* {userData?.isActive ? (
                            <i className="ti ti-discount-check-filled text-success ms-1" /> // Yeşil Tik
                        ) : (
                            <i className="ti ti-circle-x-filled text-danger ms-1" /> // Kırmızı Çarpı
                        )} */}
                    </h5>
                    <span className="badge badge-soft-dark fw-medium me-2">
                        <i className="ti ti-point-filled me-1" />
                        {userData?.title}
                    </span>
                    <span className="badge badge-soft-secondary fw-medium">
                        {/* Şirkette {experienceText} */}
                    </span>
                </div>
                <div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                            <i className="ti ti-star me-2" />
                            {t('employeesDetail.profileCard.department')}
                        </span>
                        <p className="text-dark">{userData?.department?.map(d => d.name).join(', ') || '-'}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                            <i className="ti ti-calendar-check me-2" />
                            {t('employeesDetail.profileCard.hireDate')}
                        </span>
                        <p className="text-dark">
                            {formatDate(userData?.hireDate)}
                        </p>
                    </div>
                    {userData?.terminationDate && (
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="d-inline-flex align-items-center">
                                <i className="ti ti-calendar-x me-2" />
                                İşten Çıkış Tarihi
                            </span>
                            <p className="text-dark">
                                {formatDate(userData?.terminationDate)}
                            </p>
                        </div>
                    )}
                    <div className="row gx-2 mt-3">
                        {currentUser?.permissions?.includes(PermissionType.EDIT_USERS) && (
                        <div className="col-12">
                            <div>
                                <Link
                                    to="#"
                                    className="btn btn-dark w-100"
                                    onClick={() => onEdit(userData)}                                >
                                    <i className="ti ti-edit me-1" />
                                    {t('employeesDetail.profileCard.editInfo')}
                                </Link>
                            </div>
                        </div>  
                        )}
                    </div>
                </div>
            </div>
            <div className="p-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <h6>{t('employeesDetail.profileCard.personalInfo')}</h6>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-building-store me-2" />
                        Ana Departman
                    </span>
                    <p className="text-dark">{userData?.primaryDepartment?.name || '-'}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-phone me-2" />
                        {t('employeesDetail.profileCard.phone')}
                    </span>
                    <p className="text-dark">{userData?.phone}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-mail-check me-2" />
                        {t('employeesDetail.profileCard.email')}
                    </span>
                    <Link
                        to="#"
                        className="text-info d-inline-flex align-items-center"
                    >
                        {userData?.email}
                        <i className="ti ti-copy text-dark ms-2" />
                    </Link>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-gender-male me-2" />
                        {t('employeesDetail.profileCard.gender')}
                    </span>
                    <p className="text-dark text-end">{GENDERS.find(g => g.value === userData?.gender)?.label}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-calendar me-2" />
                        {t('employeesDetail.profileCard.birthDate')}
                    </span>
                    <p className="text-dark">
                        {formatDate(userData?.birthDate)}
                    </p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2" />
                        {t('employeesDetail.profileCard.address')}
                    </span>
                    <p className="text-dark text-end">
                        {userData?.address}
                    </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-phone me-2" />
                        {t('employeesDetail.profileCard.emergencyNumber')}
                    </span>
                    <p className="text-dark">{userData?.emergencyContact}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-phone me-2" />
                        {t('employees.statusOptions.faceIdStatus')}
                    </span>
                    <p className="text-dark">{userData?.isFaceIdAllow === true ? t('employees.statusOptions.faceIdAllowed') : t('employees.statusOptions.faceIdNotAllowed')}</p>
                </div>
                {currentUser?.permissions?.includes(PermissionType.EDIT_USERS) && (
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-device-mobile me-2" />
                        Cihaz ID
                    </span>
                    <p className="text-dark mb-0" title={userData?.deviceId || ''}>
                        {userData?.deviceId || 'Eşleşmemiş'}
                    </p>
                </div>
                )}
                {currentUser?.permissions?.includes(PermissionType.EDIT_USERS) && (
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-key me-2" />
                        {t('employees.statusOptions.deviceReset')}
                    </span>
                    <Popconfirm
                        title={t('employees.statusOptions.deviceReset')}
                        description={t('employees.statusOptions.deviceResetConfirm') || 'Bu cihazı sıfırlamak istediğinize emin misiniz?'}
                        // open={confirmVisible && selectedUserId === record.id}
                        okText={t('employees.statusOptions.popconfirmOk')}
                        cancelText={t('employees.statusOptions.popconfirmCancel')}
                        okButtonProps={{
                            style:{backgroundColor: '#7338a0'}
                        }}
                        onConfirm={() => {
                            onDeviceReset(userData?.id)
                        }}
                        placement="topRight"
                        arrowPointAtCenter
                        className="custom-popconfirm"
                        // icon={<i className="ti ti-alert-triangle" />}
                    >

                        <button
                            className="btn btn-sm btn-outline-primary"
                            title={t('employees.statusOptions.deviceReset')}
                        >
                            <i className="ti ti-reload" />
                        </button>

                    </Popconfirm> 
                </div>
                )}
                {currentUser?.permissions?.includes(PermissionType.EDIT_USERS) && (
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-key me-2" />
                        Şifreyi Değiştir
                    </span>
                    <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setPwdModalOpen(true)}
                    >
                        <i className="ti ti-key" />
                    </button>
                </div>
                )}
                {onLeaveLimits && currentUser?.permissions?.includes(PermissionType.EDIT_USERS) &&(
                  <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                          <i className="ti ti-calendar-time me-2" />
                          İzin Limitleri
                      </span>
                      <button
                          className="btn btn-sm btn-outline-success"
                          onClick={() => onLeaveLimits(userData)}
                          title="İzin limitlerini düzenle"
                      >
                          <i className="ti ti-calendar-time" />
                      </button>
                  </div>
                )}
                {/* <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-key me-2" />
                        {t('employees.statusOptions.deviceReset')}
                    </span>
                    
                    <button className="btn btn-sm btn-outline-primary" onClick={() => onDeviceReset(userData?.id)}> <i className="ti ti-key" /> </button>
                </div> */}
            </div>
            <div className="p-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <h6>{t('employeesDetail.profileCard.workInfo')}</h6>
                </div>
                {currentUser?.permissions?.includes(PermissionType.VIEW_SALARIES) && (
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-e-passport me-2" />
                        {t('employeesDetail.profileCard.salary')}
                    </span>
                    <p className="text-dark">{userData?.salaries?.find(salary => salary.isActive)?.amount}</p>
                </div>
                )}
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-bookmark-plus me-2" />
                        {t('employeesDetail.profileCard.branch')}
                    </span>
                    <p className="text-dark text-end">{userData?.branch?.map(b => b.name).join(', ') || '-'}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                        <i className="ti ti-briefcase-2 me-2" />
                        {t('employeesDetail.profileCard.workType')}
                    </span>
                    <p className="text-dark text-end">{ROLES.find(role => role.value === userData?.role)?.label}</p>
                </div>
            </div>
        </div>
        <Modal
            title={'Şifre Değiştir'}
            open={pwdModalOpen}
            onCancel={() => setPwdModalOpen(false)}
            onOk={() => pwdForm.submit()}
            okText={'Kaydet'}
            cancelText={'İptal'}
            confirmLoading={pwdLoading}
            destroyOnClose
            >
            <Form form={pwdForm} layout="vertical" onFinish={handlePwdSubmit}>
                <Form.Item
                label={'Yeni Şifre'}
                name="newPassword"
                rules={[
                    { required: true, message: 'Şifre zorunludur' },
                    {
                    validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        const ok =
                        value.length >= 6
                        return ok
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                                'En az 6 karakter olmalıdır'
                            )
                            );
                    },
                    },
                ]}
                hasFeedback
                >
                <Input.Password placeholder={'Yeni şifre'} />
                </Form.Item>

                <Form.Item
                label={'Şifreyi Doğrulayın'}
                name="confirm"
                dependencies={['newPassword']}
                rules={[
                    { required: true, message: 'Tekrar şifre zorunludur' },
                    ({ getFieldValue }) => ({
                    validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) return Promise.resolve();
                        return Promise.reject(new Error('Şifreler eşleşmiyor'));
                    },
                    }),
                ]}
                hasFeedback
                >
                <Input.Password placeholder={'Yeni şifre (tekrar)'} />
                </Form.Item>

                <div className="d-flex align-items-center gap-2 mb-2">
                {/* <div style={{ flex: 1 }}> */}
                    {/* <Progress percent={strength.percent} showInfo={false} status={strength.status} /> */}
                {/* </div> */}
                {/* <small className="text-muted">{strength.label}</small> */}
                <Tooltip title={'Güçlü şifre oluştur'}>
                    <Button size="small" onClick={handleGenerate} className="ms-2">
                    <i className="ti ti-wand" /> {'Oluştur'}
                    </Button>
                </Tooltip>
                <Tooltip title={'Kopyala'}>
                    <Button size="small" onClick={handleCopy}>
                    <i className="ti ti-copy" /> {'Kopyala'}
                    </Button>
                </Tooltip>
                </div>
            </Form>
            </Modal>
    </div>
    )
};
